import styled from "styled-components";

export const AppStyled = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
